import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Star } from 'lucide-react';
import { taglines, stats } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToPackages = () => {
    const element = document.querySelector('#packages');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_ganges-weddings/artifacts/pa7yi6ud_IMG_7471.jpg"
          alt="Ganges Riverside Wedding"
          className="w-full h-full object-cover"
        />
        {/* Darker gradient on top for header visibility */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/30 to-transparent" style={{ height: '200px' }}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-amber-900/50 via-stone-900/40 to-emerald-900/30"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Star size={16} className="text-amber-600 fill-amber-600" />
            <span className="text-sm font-medium text-gray-800">
              Rated 4.9/5 by 150+ Couples
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            {taglines[0]}
          </h1>

          {/* Subheading */}
          <h2 className="text-xl md:text-2xl text-cream-100 mb-4 leading-relaxed">
            Experience the magic of a Rishikesh destination wedding with the sacred Ganges as your backdrop — at the best prices in Rishikesh.
          </h2>

          <p className="text-lg text-cream-200 mb-10 max-w-2xl">
            Premium venues. Spiritual grandeur. Unbeatable value. 
            Best-in-class pricing that respects your budget and your dreams.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-8 py-6 group"
              onClick={scrollToContact}
            >
              Check 2026 Availability
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-amber-800 text-lg px-8 py-6"
              onClick={scrollToPackages}
            >
              View Packages
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center md:text-left">
                <div className="text-3xl md:text-4xl font-bold text-amber-300 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-cream-200">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cream-50 to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
